export default __webpack_public_path__ + "static/media/Rubik-Medium.b87db4c3.woff2";